const AppVersion = {

    "app_version": "App Version",
    "update_version": "Update Version",
    "android": "Android",
    "ios": "iOS",

    "version": "Version",
    "build_number": "Build Number",
    "min_build_number": "Minimum Build Number",
    "force_update": "Force Update",
    "download_url": "Download URL",
    "release_notes": "Release Notes",
    "apk": "APK / Package File",

    "error_version": "Enter Version",
    "error_build_number": "Enter Build Number",
    "error_min_build_number": "Enter Minimum Build Number",

    "android_subtitle": "Google Play & APK distribution",
    "ios_subtitle": "App Store & TestFlight links",

}

export default AppVersion;
